/* eslint-disable unicorn/no-null */
import * as React from "react";
import Link from "next/link";
import { cx } from "@nju/css";
import { RespectMode } from "@nju/feature-portal-orchestrator";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockContent, Text } from "@nju/ui";
import { Logo } from "../shared";
import {
  HoverMenuElement,
  IHeaderMenuItemProps,
  IHeaderMenuLinksProps,
} from "../types";
import { HeaderMenuDesktopActive } from "./HeaderMenuDesktopActive";
import { HeaderNavigationDesktop } from "./HeaderNavigationDesktop";

interface IHeaderDesktopProps {
  handleToggleActiveMenuElement: (
    hoveredElement: HoverMenuElement | null,
    hiddenOnSecondHover?: boolean,
  ) => void;
  activeMenuElement: HoverMenuElement | null;
  isAccountActive: boolean;
  selectTone: "neutral" | "secondary";
  activeMenu: {
    items: IHeaderMenuItemProps[];
    links: IHeaderMenuLinksProps[];
  };
}

export function HeaderDesktop({
  handleToggleActiveMenuElement,
  activeMenuElement,
  isAccountActive,
  selectTone,
  activeMenu,
}: IHeaderDesktopProps) {
  return (
    <div
      className="w-full"
      onMouseLeave={() => {
        return handleToggleActiveMenuElement(null);
      }}
    >
      <header
        className={cx("flex w-full overflow-hidden items-center py-[26px]", {
          "bg-cerulean": !activeMenuElement,
          "bg-white": activeMenuElement,
        })}
      >
        <div className="flex items-center w-full">
          <div
            className="flex flex-row items-center"
            data-cy="header-navigation-menu"
          >
            <Logo
              href={portalRoutes.index.get()}
              tone={activeMenuElement ? "neutral" : "info"}
            />
            <HeaderNavigationDesktop
              activeMenuElement={activeMenuElement}
              handleToggleActiveMenuElement={handleToggleActiveMenuElement}
            />
          </div>
          <div className="flex ml-auto items-center gap-3">
            <Link
              data-cy="disability-button-header-desktop"
              href="https://www.njumobile.pl/bezbarier"
              passHref={true}
              target="_blank"
            >
              <A
                display="inline"
                size="inline"
                variant="simple"
                withUnderline={true}
              >
                <div className="w-[34px] h-[34px] rounded-full bg-ripeLemon flex justify-center items-center hover:bg-white">
                  <Icon
                    height={24}
                    name="universal-access-regular"
                    tone="neutral"
                    width={24}
                  />
                </div>
              </A>
            </Link>
            <div
              className="flex gap-3 items-center cursor-pointer"
              onMouseEnter={() => {
                return handleToggleActiveMenuElement(HoverMenuElement.account);
              }}
            >
              <Icon
                height={32}
                name="user-circle"
                tone={isAccountActive ? "accent" : selectTone}
                width={32}
              />
              <div className="relative">
                <Text
                  tone={isAccountActive ? "accent" : selectTone}
                  weight="bold"
                >
                  konto
                </Text>
                <div
                  className={cx(
                    "absolute bottom-[-5px] left-0 h-[4px] w-[21px] rounded-[2px] ",
                    {
                      "bg-cerulean": isAccountActive,
                    },
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
      {activeMenuElement && (
        <div className="absolute top-[80px] left-0 right-0 pt-4 pb-8 z-4 bg-white shadow-lg">
          <BlockContent grid="extraWide">
            <RespectMode mode={["ftth", "mobile", "postpaid", "fsecure"]}>
              {({ mode }) => {
                return (
                  <HeaderMenuDesktopActive
                    items={activeMenu.items}
                    links={activeMenu.links}
                    mode={mode}
                  />
                );
              }}
            </RespectMode>
          </BlockContent>
        </div>
      )}
    </div>
  );
}
